<div class="pb-8">

  <!-- Empty state -->
  <div *ngIf="!isLoading && !hasError && cards.length === 0"
    class="flex flex-col items-center justify-center py-20 text-gray-400">
    <span class="text-5xl mb-3">💬</span>
    <p class="text-sm font-medium">No reactions yet</p>
  </div>

  <!-- Error state -->
  <div *ngIf="hasError" class="flex flex-col items-center justify-center py-20 text-gray-400">
    <span class="text-5xl mb-3">⚠️</span>
    <p class="text-sm font-medium">Failed to load reactions</p>
  </div>

  <!-- ── Masonry grid ── -->
  <div class="rxn-masonry-grid">

    <ng-container *ngFor="let card of cards; trackBy: trackById">

      <!-- ══════════════════════════════════════════════ POST CARD ══ -->
      <article *ngIf="card.contentType === 'POST' && card.post as post"
        class="rxn-masonry-item bg-white rounded-2xl border border-[#e6e6e6] shadow-[0_1px_1px_rgba(0,0,0,0.04)] p-3 cursor-pointer transition-shadow hover:shadow-md"
        #cardRef (click)="navigateToPost(post.id)">

        <!-- Host row -->
        <div class="flex items-center gap-3" (click)="$event.stopPropagation()">
          <div class="flex-shrink-0">
            <img *ngIf="post.acceptedCollaborators.length === 0" class="h-10 w-10 rounded-full object-cover"
              [src]="post.hostAvatar" [alt]="post.hostName"
              onerror="this.src='https://ui-avatars.com/api/?name=' + encodeURIComponent(this.alt || 'U') + '&background=FFD4E0&color=D31148'" />
            <div *ngIf="post.acceptedCollaborators.length > 0" class="flex -space-x-2 items-center cursor-pointer"
              (click)="showCollabPost(post); $event.stopPropagation()">
              <img class="h-9 w-9 rounded-full object-cover border-2 border-white" [src]="post.hostAvatar"
                [alt]="post.hostName" />
              <img class="h-7 w-7 rounded-full object-cover border-2 border-white"
                [src]="post.acceptedCollaborators[0].profileImage?.urlSmall"
                [alt]="post.acceptedCollaborators[0].displayName" />
            </div>
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-gray-700 text-base">
              <span>{{ post.hostName }}</span>
              <ng-container *ngIf="post.acceptedCollaborators.length === 1">
                <span class="font-normal text-gray-500"> with </span>
                <span class="font-semibold">{{ post.acceptedCollaborators[0].displayName }}</span>
              </ng-container>
              <ng-container *ngIf="post.acceptedCollaborators.length >= 2">
                <span class="font-normal text-gray-500"> and </span>
                <span class="font-semibold cursor-pointer" (click)="showCollabPost(post); $event.stopPropagation()">
                  {{ post.acceptedCollaborators.length }} others
                </span>
              </ng-container>
            </div>
            <div class="text-sm text-gray-400" *ngIf="post.location">{{ post.location }}</div>
          </div>
          <button *ngIf="!post.isMyPostedPost && !post.isFollowed && post.acceptedCollaborators.length === 0"
            (click)="followPost($event, post)"
            class="px-3 py-1.5 text-sm font-medium text-green-700 bg-green-100 border border-green-600 rounded-lg transition flex-shrink-0 hover:bg-green-200">Follow</button>
          <button *ngIf="!post.isMyPostedPost && post.isFollowed && post.acceptedCollaborators.length === 0"
            (click)="unfollowPost($event, post)"
            class="px-3 py-1.5 text-sm font-medium text-gray-700 bg-[#f8f8f8] border border-[#d8d8d8] hover:bg-gray-100 rounded-lg transition flex-shrink-0">Unfollow</button>
          <button (click)="onFriendClickPost(post, $event)"
            *ngIf="!post.isMyPostedPost && post.acceptedCollaborators.length === 0"
            [disabled]="post.friendshipStatus === 'BLOCKED'" [title]="friendButtonTitle(post.friendshipStatus)"
            class="text-gray-400 flex-shrink-0 transition-colors disabled:opacity-40 hover:text-[#D31148]">
            <svg *ngIf="post.friendshipStatus === 'NONE'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
              stroke="#D31148" stroke-width="2">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="19" y1="8" x2="19" y2="14" />
              <line x1="22" y1="11" x2="16" y2="11" />
            </svg>
            <svg *ngIf="post.friendshipStatus === 'PENDING_SENT'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
              stroke="#f97316" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="17" y1="8" x2="23" y2="14" />
              <line x1="23" y1="8" x2="17" y2="14" />
            </svg>
            <svg *ngIf="post.friendshipStatus === 'PENDING_RECEIVED'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
              stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <polyline points="16 11 18 13 22 9" />
            </svg>
            <svg *ngIf="post.friendshipStatus === 'FRIENDS'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
              stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <polyline points="16 11 18 13 22 9" />
            </svg>
            <svg *ngIf="post.friendshipStatus === 'BLOCKED'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
              stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
            </svg>
          </button>
        </div>

        <!-- Background pattern post -->
        <div *ngIf="post.hasBackground && post.images.length === 0"
          class="relative mt-3 rounded-xl overflow-hidden flex items-center justify-center"
          [style.min-height]="post.title.length < 100 ? '200px' : '260px'"
          [style.max-height]="post.title.length > 500 ? '400px' : '320px'"
          [ngClass]="getPatternClass(post.backgroundPattern)" [style.background-color]="post.backgroundBg">
          <div class="absolute inset-0 px-5 py-5 overflow-y-auto" [class.flex]="post.title.length < 100"
            [class.items-center]="post.title.length < 100" [class.justify-center]="post.title.length < 100">
            <p class="text-xl font-bold leading-snug text-white text-center"
              style="text-shadow:0 1px 5px rgba(0,0,0,0.3);white-space:pre-wrap;"
              [innerHTML]="getHighlightedCaption(post.title)"></p>
          </div>
        </div>

        <!-- Image/video carousel -->
        <div *ngIf="post.images.length > 0" class="relative mt-3 rounded-xl overflow-hidden"
          (click)="navigateToPost(post.id)">
          <div class="relative w-full rounded-xl overflow-hidden bg-gray-100">
            <ng-container *ngFor="let img of post.images; let i = index">
              <img *ngIf="img.type === 'image'" [src]="img.url" [alt]="post.title" class="w-full object-cover"
                [class.block]="i === post.activeSlide" [class.hidden]="i !== post.activeSlide"
                (load)="onImageLoad($event)" />
              <!-- stopPropagation: the card wraps this in a navigate-to-post click, and
                   tapping the native play control bubbles up to it. -->
              <video *ngIf="img.type === 'video'" [appLazyMedia]="img.url" class="w-full object-cover"
                [class.block]="i === post.activeSlide" [class.hidden]="i !== post.activeSlide" controls muted
                playsinline (click)="$event.stopPropagation()"></video>
            </ng-container>
          </div>
          <ng-container *ngIf="post.images.length > 1">
            <button (click)="prevSlidePost(post, $event)"
              class="absolute left-2 top-1/2 -translate-y-1/2 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-white/80 text-[#D31148] shadow hover:bg-white">
              <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
            <button (click)="nextSlidePost(post, $event)"
              class="absolute right-2 top-1/2 -translate-y-1/2 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-white/80 text-[#D31148] shadow hover:bg-white">
              <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          </ng-container>
        </div>
        <div *ngIf="post.images.length > 1" class="mt-2 flex items-center justify-center gap-1.5">
          <button *ngFor="let img of post.images; let i = index" (click)="goToSlidePost(post, i, $event)"
            class="rounded-full transition-all duration-300"
            [class]="i === post.activeSlide ? 'h-2 w-4 bg-[#D31148]' : 'h-2 w-2 bg-[#d9d9d9]'"></button>
        </div>

        <!-- Caption -->
        <div *ngIf="post.images.length > 0 && post.description" class="mt-3">
          <div class="text-sm leading-relaxed whitespace-pre-wrap break-words mention-text" style="color:#4b5563;"
            [class.line-clamp-4]="!post.expanded" [innerHTML]="getHighlightedCaption(post.description)"></div>
          <button *ngIf="!post.expanded && post.description.length > 200"
            (click)="expandPost(post); $event.stopPropagation()"
            class="text-sm font-semibold text-gray-600 mt-0.5 hover:underline">...Read More</button>
          <button *ngIf="post.expanded" (click)="collapsePost(post); $event.stopPropagation()"
            class="text-sm font-semibold text-gray-600 mt-0.5 hover:underline">Show Less</button>
        </div>

        <!-- Reactions row -->
        <div class="mt-3 flex items-center justify-between" (click)="$event.stopPropagation()">
          <div class="flex items-center gap-4 text-md text-gray-400">
            <div class="relative flex items-center gap-1 select-none" style="overflow:visible;">
              <div *ngIf="post.showEmojiPicker"
                class="reaction-picker absolute z-[999] flex items-end gap-1 rounded-full bg-white px-3 py-2.5 shadow-[0_4px_20px_rgba(0,0,0,0.2)] border border-gray-100"
                style="bottom:calc(100% + 10px);left:-8px;pointer-events:auto;"
                (mouseleave)="closeEmojiPickerPost(post)">
                <button *ngFor="let r of REACTIONS; let i = index" (click)="onEmojiPickPost(post, r.type, $event)"
                  (mouseenter)="post.hoveredReaction = r.type" (mouseleave)="post.hoveredReaction = null"
                  class="reaction-emoji-btn flex flex-col items-center cursor-pointer"
                  [style.animation-delay.ms]="i * 30" [title]="r.label">
                  <span class="reaction-circle flex items-center justify-center rounded-full" [style.background]="r.bg"
                    [class.scale-125]="post.hoveredReaction === r.type"
                    [class.-translate-y-2]="post.hoveredReaction === r.type"
                    style="width:42px;height:42px;font-size:22px;line-height:1;transition:transform 0.15s cubic-bezier(0.34,1.56,0.64,1);">{{
                    r.emoji }}</span>
                  <span
                    class="mt-1 text-[10px] font-semibold text-gray-600 whitespace-nowrap transition-opacity duration-150"
                    [class.opacity-100]="post.hoveredReaction === r.type"
                    [class.opacity-0]="post.hoveredReaction !== r.type">{{ r.label }}</span>
                </button>
              </div>
              <button
                class="flex items-center gap-1.5 rounded-lg px-1 py-0.5 transition-all duration-150 active:scale-90"
                (click)="onReactionClickPost(post)">
                <ng-container *ngIf="!post.myReaction">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g opacity="0.7">
                      <path
                        d="M7.48047 18.35L10.5805 20.75C10.9805 21.15 11.8805 21.35 12.4805 21.35H16.2805C17.4805 21.35 18.7805 20.45 19.0805 19.25L21.4805 11.95C21.9805 10.55 21.0805 9.34997 19.5805 9.34997H15.5805C14.9805 9.34997 14.4805 8.84997 14.5805 8.14997L15.0805 4.94997C15.2805 4.04997 14.6805 3.04997 13.7805 2.74997C12.9805 2.44997 11.9805 2.84997 11.5805 3.44997L7.48047 9.54997"
                        stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" />
                      <path
                        d="M2.37988 18.35V8.55002C2.37988 7.15002 2.97988 6.65002 4.37988 6.65002H5.37988C6.77988 6.65002 7.37988 7.15002 7.37988 8.55002V18.35C7.37988 19.75 6.77988 20.25 5.37988 20.25H4.37988C2.97988 20.25 2.37988 19.75 2.37988 18.35Z"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                  </svg>
                  <span class="text-sm text-gray-400">{{ post.totalReactions }}</span>
                </ng-container>
                <ng-container *ngIf="post.myReaction">
                  <span class="reaction-bounce flex items-center justify-center rounded-full"
                    [style.background]="getReactionConfig(post.myReaction)?.bg"
                    style="width:30px;height:30px;font-size:18px;line-height:1;">{{
                    getReactionConfig(post.myReaction)?.emoji }}</span>
                  <span class="text-sm font-semibold" [style.color]="getReactionConfig(post.myReaction)?.color">{{
                    post.reactions }}</span>
                </ng-container>
              </button>
            </div>
            <span class="flex items-center gap-1 cursor-pointer" (click)="navigateToPost(post.id)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g opacity="0.7">
                  <path
                    d="M21 12C21 16.9706 16.9706 21 12 21C10.8029 21 9.6603 20.7663 8.61549 20.3419C8.41552 20.2607 8.31554 20.2201 8.23472 20.202C8.15566 20.1843 8.09715 20.1778 8.01613 20.1778C7.9333 20.1778 7.84309 20.1928 7.66265 20.2229L4.10476 20.8159C3.73218 20.878 3.54589 20.909 3.41118 20.8512C3.29328 20.8007 3.19933 20.7067 3.14876 20.5888C3.09098 20.4541 3.12203 20.2678 3.18413 19.8952L3.77711 16.3374C3.80718 16.1569 3.82222 16.0667 3.82221 15.9839C3.8222 15.9028 3.81572 15.8443 3.798 15.7653C3.77988 15.6845 3.73927 15.5845 3.65806 15.3845C3.23374 14.3397 3 13.1971 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>
              {{ post.comments }}
            </span>
            <span class="flex items-center gap-1">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g opacity="0.7">
                  <path
                    d="M20.7914 12.6075C21.0355 12.3982 21.1575 12.2936 21.2023 12.1691C21.2415 12.0598 21.2415 11.9403 21.2023 11.831C21.1575 11.7065 21.0355 11.6019 20.7914 11.3926L12.3206 4.13202C11.9004 3.77182 11.6903 3.59172 11.5124 3.58731C11.3578 3.58348 11.2101 3.6514 11.1124 3.77128C11 3.90921 11 4.18595 11 4.73942V9.03468C8.86532 9.40813 6.91159 10.4898 5.45971 12.1139C3.87682 13.8846 3.00123 16.176 3 18.551V19.163C4.04934 17.8989 5.35951 16.8766 6.84076 16.166C8.1467 15.5395 9.55842 15.1684 11 15.0706V19.2607C11 19.8141 11 20.0909 11.1124 20.2288C11.2101 20.3487 11.3578 20.4166 11.5124 20.4128C11.6903 20.4084 11.9004 20.2283 12.3206 19.8681L20.7914 12.6075Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>
              {{ post.shares }}
            </span>
          </div>
          <button class="flex h-8 w-8 items-center justify-center rounded-full bg-[#D31148] text-white"
            (click)="openReactionModalPost(post)">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M8.38965 18.49V8.33001C8.38965 7.93001 8.50965 7.54001 8.72965 7.21001L11.4596 3.15001C11.8896 2.50001 12.9596 2.04001 13.8696 2.38001C14.8496 2.71001 15.4996 3.81001 15.2896 4.79001L14.7696 8.06001C14.7296 8.36001 14.8096 8.63001 14.9796 8.84001C15.1496 9.03001 15.3996 9.15001 15.6696 9.15001H19.7796C20.5696 9.15001 21.2496 9.47001 21.6496 10.03C22.0296 10.57 22.0996 11.27 21.8496 11.98L19.3896 19.47C19.0796 20.71 17.7296 21.72 16.3896 21.72H12.4896C11.8196 21.72 10.8796 21.49 10.4496 21.06L9.16965 20.07C8.67965 19.7 8.38965 19.11 8.38965 18.49Z"
                fill="currentColor" />
              <path
                d="M5.21 6.38H4.18C2.63 6.38 2 6.98 2 8.46V18.52C2 20 2.63 20.6 4.18 20.6H5.21C6.76 20.6 7.39 20 7.39 18.52V8.46C7.39 6.98 6.76 6.38 5.21 6.38Z"
                fill="currentColor" />
            </svg>
          </button>
        </div>

      </article>
      <!-- ══════════════════════════════════════════════ END POST ══ -->


      <!-- ══════════════════════════════════════════════ EVENT CARD ══ -->
      <article *ngIf="card.contentType === 'EVENT' && card.event as event"
        class="rxn-masonry-item rounded-2xl border border-[#e6e6e6] bg-white p-3 shadow-[0_1px_1px_rgba(0,0,0,0.04)]"
        #cardRef>

        <div class="flex items-center gap-3">
          <div class="flex-shrink-0">
            <img *ngIf="event.acceptedCollaborators.length === 0" class="h-10 w-10 rounded-full object-cover"
              [src]="event.hostAvatar" [alt]="event.hostName" />
            <div *ngIf="event.acceptedCollaborators.length > 0" class="flex -space-x-2 items-center cursor-pointer"
              (click)="showCollabEvent(event); $event.stopPropagation()">
              <img class="h-9 w-9 rounded-full object-cover border-2 border-white" [src]="event.hostAvatar"
                [alt]="event.hostName" />
              <img class="h-7 w-7 rounded-full object-cover border-2 border-white"
                [src]="event.acceptedCollaborators[0].profileImage?.urlSmall"
                [alt]="event.acceptedCollaborators[0].displayName" />
            </div>
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-gray-700 text-base">
              <span>{{ event.hostName }}</span>
              <ng-container *ngIf="event.acceptedCollaborators.length === 1"><span class="font-normal text-gray-500">
                  with </span><span class="font-semibold">{{ event.acceptedCollaborators[0].displayName
                  }}</span></ng-container>
              <ng-container *ngIf="event.acceptedCollaborators.length >= 2"><span class="font-normal text-gray-500"> and
                </span><span class="font-semibold cursor-pointer"
                  (click)="showCollabEvent(event); $event.stopPropagation()">{{ event.acceptedCollaborators.length }}
                  others</span></ng-container>
            </div>
          </div>
          <button *ngIf="!event.isMyPostedEvent && !event.isFollowed && event.acceptedCollaborators.length === 0"
            (click)="followEvent($event, event)"
            class="px-3 py-1.5 text-sm font-medium text-green-700 bg-green-100 border border-green-600 rounded-lg transition flex-shrink-0">Follow</button>
          <button *ngIf="!event.isMyPostedEvent && event.isFollowed && event.acceptedCollaborators.length === 0"
            (click)="unfollowEvent($event, event)"
            class="px-3 py-1.5 text-sm font-medium text-gray-700 bg-[#f8f8f8] border border-[#d8d8d8] rounded-lg transition flex-shrink-0">Unfollow</button>
          <button (click)="onFriendClickEvent(event, $event)"
            *ngIf="!event.isMyPostedEvent && event.acceptedCollaborators.length === 0"
            [disabled]="event.friendshipStatus === 'BLOCKED'" [title]="friendButtonTitle(event.friendshipStatus)"
            class="text-gray-400 flex-shrink-0 transition-colors disabled:opacity-40 hover:text-[#D31148]">
            <svg *ngIf="event.friendshipStatus === 'NONE'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
              stroke="#D31148" stroke-width="2">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="19" y1="8" x2="19" y2="14" />
              <line x1="22" y1="11" x2="16" y2="11" />
            </svg>
            <svg *ngIf="event.friendshipStatus === 'PENDING_SENT'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
              stroke="#f97316" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="17" y1="8" x2="23" y2="14" />
              <line x1="23" y1="8" x2="17" y2="14" />
            </svg>
            <svg *ngIf="event.friendshipStatus === 'PENDING_RECEIVED'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
              stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <polyline points="16 11 18 13 22 9" />
            </svg>
            <svg *ngIf="event.friendshipStatus === 'FRIENDS'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
              stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <polyline points="16 11 18 13 22 9" />
            </svg>
            <svg *ngIf="event.friendshipStatus === 'BLOCKED'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
              stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
            </svg>
          </button>
        </div>

        <!-- Event image carousel -->
        <div class="relative mt-3 rounded-xl overflow-hidden">
          <div class="relative w-full rounded-xl overflow-hidden bg-gray-100">
            <img *ngFor="let img of event.images; let i = index" [src]="img" [alt]="event.title" loading="lazy"
              class="w-full h-auto object-cover cursor-pointer" [class.block]="i === event.activeSlide"
              [class.hidden]="i !== event.activeSlide" (load)="onImageLoad($event)"
              (click)="navigateToEvent(event.id)" />
          </div>
          <div class="absolute left-3 top-3 rounded-full px-3 py-1 text-xs font-semibold shadow-sm border"
            [ngClass]="event.minPrice === 0 && event.maxPrice === 0 ? 'bg-green-100 border-green-500 text-green-600' : 'bg-[#FFD4E0] border-[#D31148] text-[#D31148]'">
            {{ event.minPrice === 0 && event.maxPrice === 0 ? 'Free' : 'Price £' + event.minPrice + ' - £' +
            event.maxPrice }}
          </div>
          <ng-container *ngIf="event.images.length > 1">
            <button (click)="prevSlideEvent(event, $event)"
              class="absolute left-2 top-1/2 -translate-y-1/2 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-white/80 text-[#D31148] shadow hover:bg-white">
              <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M15 18l-6-6 6-6" />
              </svg>
            </button>
            <button (click)="nextSlideEvent(event, $event)"
              class="absolute right-2 top-1/2 -translate-y-1/2 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-white/80 text-[#D31148] shadow hover:bg-white">
              <svg class="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 18l6-6-6-6" />
              </svg>
            </button>
          </ng-container>
        </div>
        <div *ngIf="event.images.length > 1" class="mt-2 flex items-center justify-center gap-1">
          <button *ngFor="let img of event.images; let i = index" (click)="goToSlideEvent(event, i, $event)"
            class="rounded-full transition-all duration-300"
            [class]="i === event.activeSlide ? 'h-2 w-4 bg-[#D31148]' : 'h-2 w-2 bg-[#d9d9d9]'"></button>
        </div>

        <!-- Event reactions -->
        <div class="mt-2 flex items-center justify-between">
          <div class="flex items-center gap-4 text-md text-gray-400">
            <div class="relative flex items-center gap-1 select-none" style="overflow:visible;">
              <div *ngIf="event.showEmojiPicker"
                class="reaction-picker absolute z-[999] flex items-end gap-1 rounded-full bg-white px-3 py-2.5 shadow-[0_4px_20px_rgba(0,0,0,0.2)] border border-gray-100"
                style="bottom:calc(100% + 10px);left:-8px;pointer-events:auto;"
                (mouseleave)="closeEmojiPickerEvent(event)">
                <button *ngFor="let r of REACTIONS; let i = index" (click)="onEmojiPickEvent(event, r.type, $event)"
                  (mouseenter)="event.hoveredReaction = r.type" (mouseleave)="event.hoveredReaction = null"
                  class="reaction-emoji-btn flex flex-col items-center cursor-pointer"
                  [style.animation-delay.ms]="i * 30" [title]="r.label">
                  <span class="reaction-circle flex items-center justify-center rounded-full" [style.background]="r.bg"
                    [class.scale-125]="event.hoveredReaction === r.type"
                    [class.-translate-y-2]="event.hoveredReaction === r.type"
                    style="width:42px;height:42px;font-size:22px;line-height:1;transition:transform 0.15s cubic-bezier(0.34,1.56,0.64,1);">{{
                    r.emoji }}</span>
                  <span
                    class="mt-1 text-[10px] font-semibold text-gray-600 whitespace-nowrap transition-opacity duration-150"
                    [class.opacity-100]="event.hoveredReaction === r.type"
                    [class.opacity-0]="event.hoveredReaction !== r.type">{{ r.label }}</span>
                </button>
              </div>
              <button
                class="flex items-center gap-1.5 rounded-lg px-1 py-0.5 transition-all duration-150 active:scale-90"
                (click)="onReactionClickEvent(event)">
                <ng-container *ngIf="!event.myReaction">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g opacity="0.7">
                      <path
                        d="M7.48047 18.35L10.5805 20.75C10.9805 21.15 11.8805 21.35 12.4805 21.35H16.2805C17.4805 21.35 18.7805 20.45 19.0805 19.25L21.4805 11.95C21.9805 10.55 21.0805 9.34997 19.5805 9.34997H15.5805C14.9805 9.34997 14.4805 8.84997 14.5805 8.14997L15.0805 4.94997C15.2805 4.04997 14.6805 3.04997 13.7805 2.74997C12.9805 2.44997 11.9805 2.84997 11.5805 3.44997L7.48047 9.54997"
                        stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" />
                      <path
                        d="M2.37988 18.35V8.55002C2.37988 7.15002 2.97988 6.65002 4.37988 6.65002H5.37988C6.77988 6.65002 7.37988 7.15002 7.37988 8.55002V18.35C7.37988 19.75 6.77988 20.25 5.37988 20.25H4.37988C2.97988 20.25 2.37988 19.75 2.37988 18.35Z"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                  </svg>
                  <span class="text-sm text-gray-400">{{ event.totalReactions }}</span>
                </ng-container>
                <ng-container *ngIf="event.myReaction">
                  <span class="reaction-bounce flex items-center justify-center rounded-full"
                    [style.background]="getReactionConfig(event.myReaction)?.bg"
                    style="width:30px;height:30px;font-size:18px;line-height:1;">{{
                    getReactionConfig(event.myReaction)?.emoji }}</span>
                  <span class="text-sm font-semibold" [style.color]="getReactionConfig(event.myReaction)?.color">{{
                    event.totalReactions }}</span>
                </ng-container>
              </button>
            </div>
            <span class="flex items-center gap-1 cursor-pointer" (click)="navigateToEvent(event.id)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g opacity="0.7">
                  <path
                    d="M21 12C21 16.9706 16.9706 21 12 21C10.8029 21 9.6603 20.7663 8.61549 20.3419C8.41552 20.2607 8.31554 20.2201 8.23472 20.202C8.15566 20.1843 8.09715 20.1778 8.01613 20.1778C7.9333 20.1778 7.84309 20.1928 7.66265 20.2229L4.10476 20.8159C3.73218 20.878 3.54589 20.909 3.41118 20.8512C3.29328 20.8007 3.19933 20.7067 3.14876 20.5888C3.09098 20.4541 3.12203 20.2678 3.18413 19.8952L3.77711 16.3374C3.80718 16.1569 3.82222 16.0667 3.82221 15.9839C3.8222 15.9028 3.81572 15.8443 3.798 15.7653C3.77988 15.6845 3.73927 15.5845 3.65806 15.3845C3.23374 14.3397 3 13.1971 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>
              {{ event.comments }}
            </span>
            <span class="flex items-center gap-1">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g opacity="0.7">
                  <path
                    d="M20.7914 12.6075C21.0355 12.3982 21.1575 12.2936 21.2023 12.1691C21.2415 12.0598 21.2415 11.9403 21.2023 11.831C21.1575 11.7065 21.0355 11.6019 20.7914 11.3926L12.3206 4.13202C11.9004 3.77182 11.6903 3.59172 11.5124 3.58731C11.3578 3.58348 11.2101 3.6514 11.1124 3.77128C11 3.90921 11 4.18595 11 4.73942V9.03468C8.86532 9.40813 6.91159 10.4898 5.45971 12.1139C3.87682 13.8846 3.00123 16.176 3 18.551V19.163C4.04934 17.8989 5.35951 16.8766 6.84076 16.166C8.1467 15.5395 9.55842 15.1684 11 15.0706V19.2607C11 19.8141 11 20.0909 11.1124 20.2288C11.2101 20.3487 11.3578 20.4166 11.5124 20.4128C11.6903 20.4084 11.9004 20.2283 12.3206 19.8681L20.7914 12.6075Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>
              {{ event.shares }}
            </span>
          </div>
          <button class="flex h-8 w-8 items-center justify-center rounded-full bg-[#D31148] text-white"
            (click)="openReactionModalEvent(event)">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M8.38965 18.49V8.33001C8.38965 7.93001 8.50965 7.54001 8.72965 7.21001L11.4596 3.15001C11.8896 2.50001 12.9596 2.04001 13.8696 2.38001C14.8496 2.71001 15.4996 3.81001 15.2896 4.79001L14.7696 8.06001C14.7296 8.36001 14.8096 8.63001 14.9796 8.84001C15.1496 9.03001 15.3996 9.15001 15.6696 9.15001H19.7796C20.5696 9.15001 21.2496 9.47001 21.6496 10.03C22.0296 10.57 22.0996 11.27 21.8496 11.98L19.3896 19.47C19.0796 20.71 17.7296 21.72 16.3896 21.72H12.4896C11.8196 21.72 10.8796 21.49 10.4496 21.06L9.16965 20.07C8.67965 19.7 8.38965 19.11 8.38965 18.49Z"
                fill="currentColor" />
              <path
                d="M5.21 6.38H4.18C2.63 6.38 2 6.98 2 8.46V18.52C2 20 2.63 20.6 4.18 20.6H5.21C6.76 20.6 7.39 20 7.39 18.52V8.46C7.39 6.98 6.76 6.38 5.21 6.38Z"
                fill="currentColor" />
            </svg>
          </button>
        </div>

        <!-- Event info -->
        <div class="mt-3">
          <div class="text-lg font-semibold text-gray-800 cursor-pointer hover:text-[#D31148] transition-colors"
            (click)="navigateToEvent(event.id)">{{ event.title }}</div>
          <div class="mt-1 text-md text-gray-500">Start Date : <span class="font-medium text-[#D31148]">{{
              event.startDateLabel }}</span></div>
          <div class="text-md text-gray-500 mt-2">End Date : <span class="font-medium text-[#D31148]">{{
              event.endDateLabel }}</span></div>
          <div class="mt-2 flex items-center gap-1 text-md text-[#e91e63]">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 10c0 6-9 12-9 12S3 16 3 10a9 9 0 1 1 18 0z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
            {{ event.location || 'Online Event' }}
          </div>
        </div>
        <app-button className="w-full mt-3" size="md" class="mt-2" (click)="openBooking(event.linkToBookingSite)">Book
          Now</app-button>

      </article>
      <!-- ══════════════════════════════════════════════ END EVENT ══ -->


      <!-- ══════════════════════════════════════════════ BLOG CARD ══ -->
      <div *ngIf="card.contentType === 'BLOG' && card.blog as blog"
        class="rxn-masonry-item blog-masonry-item bg-white rounded-2xl overflow-hidden px-4 flex flex-col border border-[#e6e6e6] shadow-sm transition-all duration-250 hover:-translate-y-1 hover:shadow-md"
        #cardRef>

        <!-- Blog header -->
        <div class="flex items-center justify-between pt-2 pb-3">
          <div class="flex items-center gap-2.5">
            <div class="flex-shrink-0">
              <img *ngIf="blog.acceptedCollaborators.length === 0" [src]="blog.avatar" [alt]="blog.author"
                class="w-14 h-14 rounded-full object-cover ring-2 ring-gray-100" />
              <div *ngIf="blog.acceptedCollaborators.length > 0" class="flex -space-x-2 items-center cursor-pointer"
                (click)="showCollabBlog(blog); $event.stopPropagation()">
                <img [src]="blog.avatar" [alt]="blog.author"
                  class="h-12 w-12 rounded-full border-2 border-white object-cover ring-2 ring-gray-100" />
                <img class="h-9 w-9 rounded-full border-2 border-white object-cover"
                  [src]="blog.acceptedCollaborators[0].profileImage?.urlSmall"
                  [alt]="blog.acceptedCollaborators[0].displayName" />
              </div>
            </div>
            <div>
              <p class="font-semibold text-gray-900 text-[15px] leading-tight">{{ blog.title }}</p>
              <p class="text-sm leading-tight mt-0.5">
                <span class="text-[13px] text-[#858585] font-normal">By </span>
                <span class="text-[#D31148] font-medium">{{ blog.author }}</span>
                <ng-container *ngIf="blog.acceptedCollaborators.length === 1">
                  <span class="text-[#858585] font-normal"> with </span>
                  <span class="text-[#D31148] font-medium">{{ blog.acceptedCollaborators[0].displayName }}</span>
                </ng-container>
                <ng-container *ngIf="blog.acceptedCollaborators.length >= 2">
                  <span class="text-[#858585] font-normal"> and </span>
                  <span class="cursor-pointer text-[#D31148] font-medium hover:underline"
                    (click)="showCollabBlog(blog); $event.stopPropagation()">
                    {{ blog.acceptedCollaborators.length }} others
                  </span>
                </ng-container>
              </p>
              <p class="text-gray-400 text-[13px] mt-0.5">{{ blog.timeAgo }}</p>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <button *ngIf="!blog.isMyPostedBlog && !blog.isFollowed && blog.acceptedCollaborators.length === 0"
              (click)="followBlog($event, blog)"
              class="px-3 py-1.5 text-sm font-medium text-green-700 bg-green-100 border border-green-600 rounded-lg transition flex-shrink-0 hover:bg-green-200">Follow</button>
            <button *ngIf="!blog.isMyPostedBlog && blog.isFollowed && blog.acceptedCollaborators.length === 0"
              (click)="unfollowBlog($event, blog)"
              class="px-3 py-1.5 text-sm font-medium text-gray-700 bg-[#f8f8f8] border border-[#d8d8d8] hover:bg-gray-100 rounded-lg transition flex-shrink-0">Unfollow</button>
            <button (click)="onFriendClickBlog(blog, $event)"
              *ngIf="!blog.isMyPostedBlog && blog.acceptedCollaborators.length === 0"
              [disabled]="blog.friendshipStatus === 'BLOCKED'" [title]="friendButtonTitle(blog.friendshipStatus)"
              class="text-gray-400 flex-shrink-0 transition-colors disabled:opacity-40 hover:text-[#D31148]">
              <svg *ngIf="blog.friendshipStatus === 'NONE'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                stroke="#D31148" stroke-width="2">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="19" y1="8" x2="19" y2="14" />
                <line x1="22" y1="11" x2="16" y2="11" />
              </svg>
              <svg *ngIf="blog.friendshipStatus === 'PENDING_SENT'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                stroke="#f97316" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="17" y1="8" x2="23" y2="14" />
                <line x1="23" y1="8" x2="17" y2="14" />
              </svg>
              <svg *ngIf="blog.friendshipStatus === 'PENDING_RECEIVED'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <polyline points="16 11 18 13 22 9" />
              </svg>
              <svg *ngIf="blog.friendshipStatus === 'FRIENDS'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <polyline points="16 11 18 13 22 9" />
              </svg>
              <svg *ngIf="blog.friendshipStatus === 'BLOCKED'" class="h-6 w-6" viewBox="0 0 24 24" fill="none"
                stroke="#9ca3af" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
              </svg>
            </button>
          </div>
        </div>

        <div class="h-[1.5px] bg-[#DADADA] w-full"></div>

        <!-- Blog image carousel -->
        <ng-container *ngIf="blog.images.length > 0">
          <div class="relative mt-3 rounded-xl overflow-hidden cursor-pointer" (click)="navigateToBlog(blog._id)">
            <div class="relative w-full rounded-xl overflow-hidden bg-gray-100">
              <ng-container *ngFor="let img of blog.images; let di = index; trackBy: trackByIndex">
                <ng-container *ngIf="!isVideoSlideBlog(blog, di)">
                  <img [src]="img" alt="blog image" class="w-full object-cover" [class.block]="di === blog.activeSlide"
                    [class.hidden]="di !== blog.activeSlide" (load)="onImageLoad($event)" />
                </ng-container>
                <ng-container *ngIf="isVideoSlideBlog(blog, di)">
                  <!-- stopPropagation: the card wraps this in a navigate-to-blog click, and
                       tapping the native play control bubbles up to it. -->
                  <video controls preload="metadata" playsinline [appLazyMedia]="img" class="w-full object-cover"
                    [class.block]="di === blog.activeSlide" [class.hidden]="di !== blog.activeSlide"
                    (click)="$event.stopPropagation()"></video>
                </ng-container>
              </ng-container>
            </div>
            <button (click)="$event.stopPropagation()"
              class="absolute top-6 right-2 z-10 w-9 h-9 rounded-full bg-white flex items-center justify-center shadow-md">
              <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-[#D31148]" viewBox="0 0 24 24"
                [attr.fill]="blog.myReaction === 'LIKE' ? 'currentColor' : 'none'" stroke="currentColor"
                stroke-width="1.5">
                <path
                  d="M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" />
              </svg>
            </button>
          </div>
          <div *ngIf="blog.images.length > 1" class="flex items-center justify-center gap-1.5 pt-3 pb-1">
            <button *ngFor="let img of blog.images; let di = index; trackBy: trackByIndex"
              (click)="goToSlideBlog(blog, di)" class="rounded-full transition-all duration-300 focus:outline-none"
              [style.height]="'8px'" [style.width]="di === blog.activeSlide ? '20px' : '8px'"
              [style.background-color]="di === blog.activeSlide ? '#e0144c' : '#d1d5db'"></button>
          </div>
          <div *ngIf="blog.images.length <= 1" class="pt-3 pb-1"></div>
        </ng-container>

        <!-- Blog text -->
        <div class="pt-2 pb-2 flex-1 cursor-pointer" (click)="navigateToBlog(blog._id)">
          <p class="text-gray-700 text-sm leading-relaxed line-clamp-4">
            {{ blog.text }}
            <span *ngIf="blog.hasMore" class="text-[#e0144c] font-semibold cursor-pointer hover:underline"> Read
              More</span>
          </p>
        </div>

        <!-- Blog reactions row -->
        <div class="mt-2 mb-4 flex items-center justify-between" (click)="$event.stopPropagation()">
          <div class="flex items-center gap-4 text-md text-gray-400">
            <div class="relative flex items-center gap-1 select-none" style="overflow:visible;">
              <div *ngIf="blog.showEmojiPicker"
                class="reaction-picker absolute z-[999] flex items-end gap-1 rounded-full bg-white px-3 py-2.5 shadow-[0_4px_20px_rgba(0,0,0,0.2)] border border-gray-100"
                style="bottom:calc(100% + 10px);left:-8px;pointer-events:auto;"
                (mouseleave)="closeEmojiPickerBlog(blog)">
                <button *ngFor="let r of REACTIONS; let i = index" (click)="onEmojiPickBlog(blog, r.type, $event)"
                  (mouseenter)="blog.hoveredReaction = r.type" (mouseleave)="blog.hoveredReaction = null"
                  class="reaction-emoji-btn flex flex-col items-center cursor-pointer"
                  [style.animation-delay.ms]="i * 30" [title]="r.label">
                  <span class="reaction-circle flex items-center justify-center rounded-full" [style.background]="r.bg"
                    [class.scale-125]="blog.hoveredReaction === r.type"
                    [class.-translate-y-2]="blog.hoveredReaction === r.type"
                    style="width:42px;height:42px;font-size:22px;line-height:1;transition:transform 0.15s cubic-bezier(0.34,1.56,0.64,1);">{{
                    r.emoji }}</span>
                  <span
                    class="mt-1 text-[10px] font-semibold text-gray-600 whitespace-nowrap transition-opacity duration-150"
                    [class.opacity-100]="blog.hoveredReaction === r.type"
                    [class.opacity-0]="blog.hoveredReaction !== r.type">{{ r.label }}</span>
                </button>
              </div>
              <button
                class="flex items-center gap-1.5 rounded-lg px-1 py-0.5 transition-all duration-150 active:scale-90"
                (click)="onReactionClickBlog(blog)">
                <ng-container *ngIf="!blog.myReaction">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g opacity="0.7">
                      <path
                        d="M7.48047 18.35L10.5805 20.75C10.9805 21.15 11.8805 21.35 12.4805 21.35H16.2805C17.4805 21.35 18.7805 20.45 19.0805 19.25L21.4805 11.95C21.9805 10.55 21.0805 9.34997 19.5805 9.34997H15.5805C14.9805 9.34997 14.4805 8.84997 14.5805 8.14997L15.0805 4.94997C15.2805 4.04997 14.6805 3.04997 13.7805 2.74997C12.9805 2.44997 11.9805 2.84997 11.5805 3.44997L7.48047 9.54997"
                        stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" />
                      <path
                        d="M2.37988 18.35V8.55002C2.37988 7.15002 2.97988 6.65002 4.37988 6.65002H5.37988C6.77988 6.65002 7.37988 7.15002 7.37988 8.55002V18.35C7.37988 19.75 6.77988 20.25 5.37988 20.25H4.37988C2.97988 20.25 2.37988 19.75 2.37988 18.35Z"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                  </svg>
                  <span class="text-sm text-gray-400">{{ blog.totalReactions }}</span>
                </ng-container>
                <ng-container *ngIf="blog.myReaction">
                  <span class="reaction-bounce flex items-center justify-center rounded-full"
                    [style.background]="getReactionConfig(blog.myReaction)?.bg"
                    style="width:30px;height:30px;font-size:18px;line-height:1;">{{
                    getReactionConfig(blog.myReaction)?.emoji }}</span>
                  <span class="text-sm font-semibold" [style.color]="getReactionConfig(blog.myReaction)?.color">{{
                    blog.reactions }}</span>
                </ng-container>
              </button>
            </div>
            <span class="flex items-center gap-1 cursor-pointer" (click)="navigateToBlog(blog._id)">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g opacity="0.7">
                  <path
                    d="M21 12C21 16.9706 16.9706 21 12 21C10.8029 21 9.6603 20.7663 8.61549 20.3419C8.41552 20.2607 8.31554 20.2201 8.23472 20.202C8.15566 20.1843 8.09715 20.1778 8.01613 20.1778C7.9333 20.1778 7.84309 20.1928 7.66265 20.2229L4.10476 20.8159C3.73218 20.878 3.54589 20.909 3.41118 20.8512C3.29328 20.8007 3.19933 20.7067 3.14876 20.5888C3.09098 20.4541 3.12203 20.2678 3.18413 19.8952L3.77711 16.3374C3.80718 16.1569 3.82222 16.0667 3.82221 15.9839C3.8222 15.9028 3.81572 15.8443 3.798 15.7653C3.77988 15.6845 3.73927 15.5845 3.65806 15.3845C3.23374 14.3397 3 13.1971 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>
              {{ blog.comments }}
            </span>
            <span class="flex items-center gap-1">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g opacity="0.7">
                  <path
                    d="M20.7914 12.6075C21.0355 12.3982 21.1575 12.2936 21.2023 12.1691C21.2415 12.0598 21.2415 11.9403 21.2023 11.831C21.1575 11.7065 21.0355 11.6019 20.7914 11.3926L12.3206 4.13202C11.9004 3.77182 11.6903 3.59172 11.5124 3.58731C11.3578 3.58348 11.2101 3.6514 11.1124 3.77128C11 3.90921 11 4.18595 11 4.73942V9.03468C8.86532 9.40813 6.91159 10.4898 5.45971 12.1139C3.87682 13.8846 3.00123 16.176 3 18.551V19.163C4.04934 17.8989 5.35951 16.8766 6.84076 16.166C8.1467 15.5395 9.55842 15.1684 11 15.0706V19.2607C11 19.8141 11 20.0909 11.1124 20.2288C11.2101 20.3487 11.3578 20.4166 11.5124 20.4128C11.6903 20.4084 11.9004 20.2283 12.3206 19.8681L20.7914 12.6075Z"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
              </svg>
              {{ blog.shares }}
            </span>
          </div>
          <button class="flex h-8 w-8 items-center justify-center rounded-full bg-[#D31148] text-white"
            (click)="openReactionModalBlog(blog)">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M8.38965 18.49V8.33001C8.38965 7.93001 8.50965 7.54001 8.72965 7.21001L11.4596 3.15001C11.8896 2.50001 12.9596 2.04001 13.8696 2.38001C14.8496 2.71001 15.4996 3.81001 15.2896 4.79001L14.7696 8.06001C14.7296 8.36001 14.8096 8.63001 14.9796 8.84001C15.1496 9.03001 15.3996 9.15001 15.6696 9.15001H19.7796C20.5696 9.15001 21.2496 9.47001 21.6496 10.03C22.0296 10.57 22.0996 11.27 21.8496 11.98L19.3896 19.47C19.0796 20.71 17.7296 21.72 16.3896 21.72H12.4896C11.8196 21.72 10.8796 21.49 10.4496 21.06L9.16965 20.07C8.67965 19.7 8.38965 19.11 8.38965 18.49Z"
                fill="currentColor" />
              <path
                d="M5.21 6.38H4.18C2.63 6.38 2 6.98 2 8.46V18.52C2 20 2.63 20.6 4.18 20.6H5.21C6.76 20.6 7.39 20 7.39 18.52V8.46C7.39 6.98 6.76 6.38 5.21 6.38Z"
                fill="currentColor" />
            </svg>
          </button>
        </div>

      </div>
      <!-- ══════════════════════════════════════════════ END BLOG ══ -->

    </ng-container>
  </div>
  <!-- ── End masonry grid ── -->

  <!-- Infinite scroll sentinel -->
  <div #loadMoreSentinel class="h-4 w-full"></div>

  <!-- Loading spinner -->
  <div *ngIf="isLoading" class="flex justify-center py-8">
    <div class="w-8 h-8 border-4 border-[#e91e63] border-t-transparent rounded-full animate-spin"></div>
  </div>

</div>


<!-- ── Shared Reaction Modal ── -->
<app-modal [isOpen]="isReactionOpen" (close)="closeReactionModal()" className="max-w-[700px]">
  <div class="relative w-full h-full flex flex-col bg-white dark:bg-gray-900 rounded-3xl overflow-hidden">
    <div class="flex-shrink-0 bg-white dark:bg-gray-900 border-b border-[#f0f0f0]">
      <div class="flex items-center gap-1 overflow-x-auto px-5 pt-5 pb-3 lg:px-8">
        <button (click)="setReactionFilter(null)"
          class="flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors"
          [class.text-[#D31148]]="activeReactionFilter === null" [class.border-b-2]="activeReactionFilter === null"
          [class.border-[#D31148]]="activeReactionFilter === null"
          [class.text-gray-500]="activeReactionFilter !== null">
          All <span class="font-bold">{{ reactionData?.total ?? 0 }}</span>
        </button>
        <ng-container *ngFor="let r of REACTIONS">
          <button (click)="setReactionFilter(r.type)"
            class="flex items-center gap-1 px-3 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors"
            [class.text-[#D31148]]="activeReactionFilter === r.type"
            [class.border-b-2]="activeReactionFilter === r.type"
            [class.border-[#D31148]]="activeReactionFilter === r.type"
            [class.text-gray-500]="activeReactionFilter !== r.type">
            <span style="font-size:18px;line-height:1;">{{ r.emoji }}</span>
            <span>{{ reactionData?.counts?.[r.type] ?? 0 }}</span>
          </button>
        </ng-container>
      </div>
    </div>
    <div class="flex-1 overflow-y-auto px-5 py-4 lg:px-8">
      <div *ngIf="reactionsLoading" class="flex items-center justify-center py-12">
        <div class="h-8 w-8 animate-spin rounded-full border-4 border-[#e8e8e8] border-t-[#D31148]"></div>
      </div>
      <div *ngIf="!reactionsLoading" class="space-y-1">
        <div *ngFor="let item of filteredReactions"
          class="flex items-center gap-3 rounded-xl px-2 py-2.5 hover:bg-[#fafafa] transition-colors">
          <div class="relative flex-shrink-0">
            <img
              [src]="item.user?.profileImage?.urlSmall || avatarFallback(item.user?.displayName)"
              class="h-11 w-11 rounded-full object-cover border border-[#f0f0f0]" [alt]="item.user?.displayName" />
            <span
              class="absolute -bottom-0.5 -right-0.5 flex h-5 w-5 items-center justify-center rounded-full border-2 border-white text-[11px] shadow-sm"
              [style.background]="getReactionConfig(item.type)?.bg">{{ item.emoji }}</span>
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-semibold text-gray-800 text-sm truncate">{{ item.user?.displayName }}</div>
            <div class="text-xs text-gray-400 truncate">{{ item.user?.userName }}</div>
          </div>
          <div class="flex items-center gap-2 flex-shrink-0">

            <!-- Friend request button -->
            <button (click)="onModalFriendClick(item, $event)" *ngIf="!item.isMe"
              [title]="friendButtonTitle(item.friendship.status ?? 'NONE')"
              [disabled]="item.friendship.status === 'BLOCKED'"
              class="flex items-center justify-center w-8 h-8 rounded-full border transition-colors disabled:opacity-40"
              [ngClass]="item.friendship.status === 'FRIENDS'
                    ? 'border-emerald-500 text-emerald-500 hover:bg-emerald-50'
                    : item.friendship.status === 'PENDING_SENT'
                        ? 'border-orange-400 text-orange-400 hover:bg-orange-50'
                        : 'border-[#D31148] text-[#D31148] hover:bg-[#FFF0F3]'">

              <!-- NONE: add friend -->
              <svg *ngIf="!item.friendship.status || item.friendship.status === 'NONE'" width="15" height="15"
                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="19" y1="8" x2="19" y2="14" />
                <line x1="22" y1="11" x2="16" y2="11" />
              </svg>

              <!-- PENDING_SENT: cancel -->
              <svg *ngIf="item.friendship.status === 'PENDING_SENT'" width="15" height="15" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <line x1="17" y1="8" x2="23" y2="14" />
                <line x1="23" y1="8" x2="17" y2="14" />
              </svg>

              <!-- PENDING_RECEIVED -->
              <svg *ngIf="item.friendship.status === 'PENDING_RECEIVED'" width="15" height="15" viewBox="0 0 24 24"
                fill="none" stroke="#6366f1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <polyline points="16 11 18 13 22 9" />
              </svg>

              <!-- FRIENDS: unfriend -->
              <svg *ngIf="item.friendship.status === 'FRIENDS'" width="15" height="15" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <polyline points="16 11 18 13 22 9" />
              </svg>

              <!-- BLOCKED -->
              <svg *ngIf="item.friendship.status === 'BLOCKED'" width="15" height="15" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
              </svg>

            </button>

            <!-- Follow / Unfollow button -->
            <button (click)="onModalFollowClick(item, $event)" *ngIf="!item.isMe"
              class="flex-shrink-0 px-3 py-1.5 text-xs font-semibold rounded-lg transition-colors" [ngClass]="item.isFollowed
                    ? 'text-gray-700 bg-[#f8f8f8] border border-[#d8d8d8] hover:bg-gray-100'
                    : 'text-green-700 bg-green-100 border border-green-600 hover:bg-green-200'">
              {{ item.isFollowed ? 'Unfollow' : 'Follow' }}
            </button>

          </div>
        </div>
        <div *ngIf="filteredReactions.length === 0"
          class="flex flex-col items-center justify-center py-12 text-gray-400">
          <span style="font-size:40px;">🤷</span>
          <p class="mt-2 text-sm">No reactions yet</p>
        </div>
      </div>
    </div>
  </div>
</app-modal>


<!-- ── Shared Collab Modal ── -->
<div *ngIf="showCollabModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
  (click)="closeCollabModal()">
  <div class="max-h-[80vh] w-full max-w-sm overflow-hidden rounded-2xl bg-white" (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between border-b border-gray-200 p-4">
      <h3 class="text-lg font-bold">Collaborators</h3>
      <button (click)="closeCollabModal()" class="text-gray-400 transition-colors hover:text-gray-600">
        <svg class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
    <div class="max-h-[calc(80vh-80px)] overflow-y-auto">
      <div class="flex items-center gap-3 p-4 transition-colors hover:bg-gray-50">
        <img [src]="collabAuthorAvatar" [alt]="collabAuthorName"
          class="h-12 w-12 rounded-full border-2 border-white object-cover" />
        <div class="min-w-0 flex-1">
          <div class="truncate font-semibold text-gray-900">{{ collabAuthorName }}</div>
          <div class="text-sm text-gray-500">Author</div>
        </div>
      </div>
      <div *ngFor="let collab of collabCollaborators"
        class="flex items-center gap-3 p-4 transition-colors hover:bg-gray-50">
        <img [src]="collab.profileImage?.urlSmall" [alt]="collab.displayName"
          class="h-12 w-12 rounded-full border-2 border-white object-cover" />
        <div class="min-w-0 flex-1">
          <div class="truncate font-semibold text-gray-900">{{ collab.displayName }}</div>
          <div class="truncate text-sm text-gray-500">@{{ collab.userName }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-friend-request-limit-popup [isOpen]="showFriendLimitPopup" [hours]="friendLimitHours"
  (closed)="showFriendLimitPopup = false"></app-friend-request-limit-popup>

<app-confirmation-popup [isOpen]="showUnfriendConfirm" icon="warning" title="Unfriend User"
  message="Are you sure you want to unfriend this user?" confirmLabel="Unfriend" cancelLabel="Cancel"
  (confirmed)="confirmUnfriend()" (cancelled)="cancelUnfriendConfirm()"></app-confirmation-popup>

<style>
  .rxn-masonry-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-auto-rows: 10px;
    gap: 0 20px;
  }

  .rxn-masonry-item {
    align-self: start;
    min-width: 0;
  }

  @media (max-width: 1380px) {
    .rxn-masonry-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 900px) {
    .rxn-masonry-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 560px) {
    .rxn-masonry-grid {
      grid-template-columns: 1fr;
    }
  }
</style>